import { render, staticRenderFns } from "./PlanFunctionDetailModal.vue?vue&type=template&id=6f2dc99b&lang=pug"
import script from "./PlanFunctionDetailModal.vue?vue&type=script&lang=ts"
export * from "./PlanFunctionDetailModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports